<template>
  <gg-card class="fill-height">
    <v-skeleton-loader :loading="loading" type="article">
      <gg-card-header>
        Affiliate Profile
        <gg-btn primary class="float-right" @click="triggerModal">
          Edit
        </gg-btn>
      </gg-card-header>
      <gg-card-text>
        <v-row>
          <v-col cols="12">
            <div>
              Current Classification: <b>{{ classification }}</b>
            </div>
          </v-col>
        </v-row>
      </gg-card-text>
    </v-skeleton-loader>

    <gg-modal v-if="modal" :is-active="modal" @close="triggerModal">
      <template v-slot:toolbar>Select Your Classification</template>
      <template v-slot:body>
        <gg-select label="Classification" :items="items" v-model="selected"/>
      </template>
      <template v-slot:actions>
        <gg-btn secondary @click="triggerModal">Cancel</gg-btn>
        <gg-btn primary :loading="pending" @click="changeClassification">Save</gg-btn>
      </template>
    </gg-modal>
  </gg-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Classification',
  props: {
    loading: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    items: [
      'Instructor/Education',
      'Blogger',
      'Web Designer/Web Developer',
      'Marketing Agency',
      'Coupon/Deals Website',
      'Shopping/Hosting Comparison',
      'Search Engine Marketing',
      'Other'
    ],
    modal: false,
    selected: '',
    pending: false
  }),
  computed: {
    ...mapGetters({
      profile: 'affiliates/profile'
    }),
    classification () {
      return this.profile ? this.profile.classification : ''
    }
  },
  methods: {
    ...mapActions({
      setClassification: 'affiliates/setClassification',
      reportError: 'reportError'
    }),
    triggerModal () {
      this.selected = this.classification
      this.modal = !this.modal
    },
    async changeClassification () {
      try {
        this.pending = true
        await this.setClassification(this.selected)
        this.modal = false
      } catch (e) {
        this.reportError(e)
      } finally {
        this.pending = false
      }
    }
  }
}
</script>

<style scoped>

</style>
